// What @capacitor-community/bluetooth-le rejects initialize() with when this device can't use BLE at all
const BLE_UNAVAILABLE_MESSAGES = [
  'BLE permission denied',
  'BLE unsupported',
  'Permission denied.',
  'Web Bluetooth API not available in this browser.',
]

export const isBleUnavailableError = (error: unknown) =>
  error instanceof Error && BLE_UNAVAILABLE_MESSAGES.includes(error.message)
